var _defs, _g, _path, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 285.544,
    height: 56.117,
    viewBox: "0 0 285.544 56.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f9fcfb;}.b{fill:#fe648d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.813 24)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M969.232-1688.269a2.966,2.966,0,0,1-1.08,2.385,3.768,3.768,0,0,1-2.516.843H961.67v-1.567h4.217a1.918,1.918,0,0,0,1.3-.458,1.538,1.538,0,0,0,.527-1.221,1.5,1.5,0,0,0-.527-1.208,1.954,1.954,0,0,0-1.3-.447h-5.139v7.431H959.18v-9h6.455a3.736,3.736,0,0,1,2.516.856A2.945,2.945,0,0,1,969.232-1688.269Z",
    transform: "translate(-959.18 1691.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1060.4-1682.5h-7.773v-9h7.773v1.567H1054.2v5.864h6.206Zm-.409-3.783h-5.139v-1.567h5.139Z",
    transform: "translate(-1034.856 1691.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1145.054-1682.5h-7.774v-9h7.774v1.567h-6.206v5.864h6.206Zm-.409-3.783h-5.139v-1.567h5.139Z",
    transform: "translate(-1103.405 1691.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1231.737-1682.493h-2.305l-2.516-2.53h-3.386v-1.567h4.217a2.659,2.659,0,0,0,1.463-.38,1.434,1.434,0,0,0,.671-1.272q0-1.681-2.134-1.68h-5.139v7.431h-1.567v-9h6.455a4.773,4.773,0,0,1,2.807.753,2.885,2.885,0,0,1,1.225,2.522,2.866,2.866,0,0,1-.715,1.953,3.5,3.5,0,0,1-1.8,1.069Z",
    transform: "translate(-1171.234 1691.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1327.384-1689.933h-6.206v7.431h-1.567v-9h7.774Zm-.409,3.648h-5.139v-1.567h5.139Z",
    transform: "translate(-1251.056 1691.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1412.862-1687.1a4.515,4.515,0,0,1-1.278,3.294,4.363,4.363,0,0,1-3.254,1.3h-2.516a4.373,4.373,0,0,1-3.249-1.3,4.493,4.493,0,0,1-1.284-3.294,4.2,4.2,0,0,1,1.272-3.188,4.533,4.533,0,0,1,3.262-1.212h2.516a4.525,4.525,0,0,1,3.268,1.212A4.213,4.213,0,0,1,1412.862-1687.1Zm-1.554.131a2.879,2.879,0,0,0-.837-2.134,2.912,2.912,0,0,0-2.142-.829h-2.516a2.9,2.9,0,0,0-2.128.829,2.879,2.879,0,0,0-.837,2.134,2.771,2.771,0,0,0,.837,2.094,2.944,2.944,0,0,0,2.128.8h2.516a2.967,2.967,0,0,0,2.142-.8A2.771,2.771,0,0,0,1411.307-1686.969Z",
    transform: "translate(-1317.192 1691.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1513.477-1682.493h-2.305l-2.516-2.53h-3.386v-1.567h4.217a2.659,2.659,0,0,0,1.463-.38,1.434,1.434,0,0,0,.671-1.272q0-1.681-2.134-1.68h-5.139v7.431h-1.567v-9h6.455a4.773,4.773,0,0,1,2.807.753,2.885,2.885,0,0,1,1.225,2.522,2.866,2.866,0,0,1-.715,1.953,3.5,3.5,0,0,1-1.8,1.069Z",
    transform: "translate(-1399.387 1691.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1612.738-1683.063h-1.765l-1.3-6.3-3.017,5.811a.928.928,0,0,1-.843.594,1,1,0,0,1-.922-.607l-3.016-5.8-1.292,6.3H1598.8l2.008-8.262a1.236,1.236,0,0,1,.348-.62.868.868,0,0,1,.624-.264c.34,0,.666.3.972.89l3.013,5.9,3.024-5.908c.308-.59.631-.883.976-.883a.9.9,0,0,1,.632.278,1.3,1.3,0,0,1,.342.607Z",
    transform: "translate(-1477.144 1692.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1724.788-1682.607l-2.024-.013-1.5-2.516h-4.272l.945-1.567h2.377l-1.56-2.585-4.059,6.684h-2.012l4.888-8.143a2.121,2.121,0,0,1,.514-.58,1.223,1.223,0,0,1,.711-.3,1.17,1.17,0,0,1,.711.289,2.07,2.07,0,0,1,.513.593Z",
    transform: "translate(-1569.364 1691.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1824.374-1683.288q0,.87-.6.869a1.5,1.5,0,0,1-.978-.536l-5.767-5.8v6.244h-1.554v-8.222a.9.9,0,0,1,.171-.548.569.569,0,0,1,.487-.23,1.315,1.315,0,0,1,.9.46l5.771,5.784v-6.244h1.567v8.222Z",
    transform: "translate(-1652.611 1691.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1916.469-1682.5h-5.086a4.372,4.372,0,0,1-3.249-1.3,4.493,4.493,0,0,1-1.284-3.294,4.2,4.2,0,0,1,1.271-3.188,4.537,4.537,0,0,1,3.262-1.212h5.086v1.567h-5.086a2.9,2.9,0,0,0-2.128.829,2.879,2.879,0,0,0-.837,2.134,2.763,2.763,0,0,0,.837,2.094,2.943,2.943,0,0,0,2.128.8h5.086Z",
    transform: "translate(-1726.602 1691.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2007.734-1682.5h-7.774v-9h7.774v1.567h-6.206v5.864h6.206Zm-.409-3.783h-5.139v-1.567h5.139Z",
    transform: "translate(-1802.003 1691.635)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1325.741-1964.364c-.474,0-.943-.014-1.411-.038a28.713,28.713,0,0,0,21.594-11.072,26.924,26.924,0,0,1-24.07,9.181,26.968,26.968,0,0,1-22.86-21.828c-.027-.232-.054-.465-.075-.7l4.177,3.55-6.111-11.591-5.595,11.164,3.618-2.934c.032.2.065.406.1.608a28.674,28.674,0,0,0,28.474,25.611,28.651,28.651,0,0,0,24.774-14.289A26.914,26.914,0,0,1,1325.741-1964.364Z",
    transform: "translate(-1291.39 2018.528)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1384.5-2114.21c-.032-.2-.066-.406-.1-.608a28.674,28.674,0,0,0-28.474-25.611,28.651,28.651,0,0,0-24.774,14.289,26.922,26.922,0,0,1,22.617-12.333c.474,0,.943.014,1.411.038a28.714,28.714,0,0,0-21.594,11.072,26.924,26.924,0,0,1,24.07-9.18,26.968,26.968,0,0,1,22.86,21.828c.027.232.054.465.076.7l-4.177-3.549,6.111,11.591,5.595-11.164Z",
    transform: "translate(-1325.149 2140.43)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.296 14.93)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3.32,
    height: 14.036,
    transform: "translate(0 12.149)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3.32,
    height: 14.036,
    transform: "translate(21.053 12.225)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3.32,
    height: 26.26,
    transform: "translate(10.489)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo_horizontal.5b06513a0f1de359466aabf4ccbc34e0.svg";
export { ForwardRef as ReactComponent };